import React from "react";

/**
 * Reusable modal styled like the DiscoverSettings popup (overlay + centered
 * card + close icon + footer). Pass `title`, `children` as the body content,
 * and a `footer` node (usually action buttons). `className` is added to the
 * modal body so callers can size/style a specific modal.
 */
const Modal = (props) => {
  const {
    title = "",
    children = null,
    footer = null,
    onClose = () => {},
    className = "",
    showClose = true,
    disableClose = false,
  } = props || {};

  const handleClose = () => {
    if (!disableClose) {
      onClose();
    }
  };

  return (
    <div className="commonModal">
      <div className={`commonModalBody ${className}`.trim()}>
        {showClose && (
          <i className="material-icons commonModalClose" onClick={handleClose}>
            close
          </i>
        )}
        <div className="commonModalCard">
          {title && <h3 className="commonModalTitle">{title}</h3>}
          <div className="commonModalContent">{children}</div>
        </div>
        {footer && <div className="commonModalFooter">{footer}</div>}
      </div>
      <div className="commonModalOverlay" onClick={handleClose} />
    </div>
  );
};

export default Modal;
export { Modal };
